module.exports = __webpack_public_path__ + "img/40.d2cf88f6.png";